import type { ContractorTranslation } from './en';

export const ptBR: ContractorTranslation = {
  common: {
    cancel: 'Cancelar',
    save: 'Salvar',
    retry: 'Tentar novamente',
    download: 'Baixar',
    continue: 'Continuar',
    yes: 'Sim',
    no: 'Não',
    genericError: 'Algo deu errado. Tente novamente.',
    networkError: 'Não foi possível conectar ao DubForge. Verifique sua conexão com a internet.',
  },
  app: {
    tagline: 'Tarefas de dublagem, arquivos e revisões em um só lugar.',
    startupFailed: 'Não foi possível iniciar o DubForge',
    notFoundTitle: 'Página não encontrada',
    notFoundBody: 'Essa página não existe ou você não tem acesso a ela.',
    goHome: 'Ir para o início',
    crashTitle: 'Algo deu errado',
    crashBody: 'Tente recarregar a página.',
    reload: 'Recarregar',
  },
  language: {
    label: 'Idioma',
    change: 'Mudar idioma',
  },
  welcome: {
    title: 'Boas-vindas ao DubForge',
    body: 'Escolha seu idioma. O DubForge e suas notificações do Discord vão usar esse idioma.',
    changeLater: 'Você pode mudar isso a qualquer momento no menu de idioma, no canto superior direito.',
  },
  nav: {
    myAssignments: 'Minhas tarefas',
    openMenu: 'Abrir menu',
    account: 'Conta',
    notificationEmail: 'E-mail para notificações',
    signOut: 'Sair',
    roleAdmin: 'Administração',
    roleContractor: 'Dublagem',
    lightMode: 'Modo claro',
    darkMode: 'Modo escuro',
  },
  login: {
    signIn: 'Entrar com o Discord',
    onlyInvited: 'Só contas do Discord adicionadas pelo dono do canal podem entrar.',
    signingIn: 'Entrando…',
    backToSignIn: 'Voltar para o login',
    failed: 'Não foi possível entrar. Tente novamente.',
  },
  authErrors: {
    not_invited: 'Esta conta do Discord não foi adicionada ao DubForge. Peça ao dono do canal para adicionar você.',
    access_off: 'Seu acesso ao DubForge foi desativado.',
    discord_only: 'Você só pode entrar com o Discord.',
  },
  errors: {
    not_signed_in: 'Sua sessão expirou. Entre novamente.',
    access_off: 'Seu acesso ao DubForge foi desativado.',
    admins_only: 'Você não tem permissão para fazer isso.',
    not_found: 'Esse item não existe ou não está mais disponível.',
    invalid_request: 'Algo nesta solicitação não é válido. Verifique e tente novamente.',
    conflict: 'Isso já existe.',
    already_approved: 'Esta tarefa já foi aprovada, então não é preciso enviar mais nada.',
    not_audio: 'Só é possível enviar arquivos WAV ou MP3. Envie apenas sua faixa de voz.',
    upload_incomplete: 'O envio não foi concluído. Tente novamente.',
    discord_unreachable: 'Não foi possível conectar ao Discord. Tente novamente mais tarde.',
    server_error: 'Algo deu errado do nosso lado. Tente novamente.',
  },
  notifications: {
    title: 'Notificações',
    openWithCount: 'Notificações ({{count}} não lidas)',
    markAllRead: 'Marcar todas como lidas',
    empty: 'Nada por aqui ainda.',
  },
  emailSettings: {
    body: 'Enviamos um e-mail quando você recebe uma nova tarefa e quando seu trabalho é revisado.',
    label: 'Endereço de e-mail',
    fromDiscord: 'Veio da sua conta do Discord. Troque se preferir outro endereço.',
    saved: 'Endereço de e-mail salvo',
    invalid: 'Digite um endereço de e-mail válido.',
    missing: 'Ainda não há um endereço de e-mail. Adicione um para receber notificações.',
  },
  status: {
    Assigned: 'Atribuída',
    InProgress: 'Em andamento',
    Submitted: 'Aguardando revisão',
    ChangesRequested: 'Alterações solicitadas',
    Approved: 'Aprovada',
  },
  assetKind: {
    package: 'Pacote de dublagem (vídeo + voz + SFX)',
    video: 'Vídeo de referência (720p)',
    sfx: 'Faixa de SFX / música',
    voice: 'Faixa de voz original',
    script: 'Roteiro',
    other: 'Outro',
  },
  translation: {
    machine: 'Tradução automática',
    showOriginal: 'Ver original',
    showTranslation: 'Ver tradução',
  },
  uploader: {
    progress: '{{percent}}% de {{size}}',
    queued: 'Aguardando envio: {{count}}',
    keepOpen: 'Mantenha esta aba aberta até terminar.',
    cancelled: 'Envio cancelado',
    done: '{{name}} enviado',
    failed: 'Falha no envio: {{error}}',
  },
  my: {
    greeting: 'Olá, {{name}}',
    subtitle: 'Suas tarefas de dublagem.',
    emptyTitle: 'Nenhuma tarefa ainda',
    emptyBody: 'Quando você receber um vídeo, vai chegar uma mensagem no Discord e ele vai aparecer aqui.',
    todo: 'A fazer',
    waiting: 'Aguardando revisão',
    done: 'Concluídas',
    updated: 'Atualizado {{when}}',
  },
  assignment: {
    back: 'Minhas tarefas',
    dubIn: 'Dublagem: {{language}}',
    paid: 'Pago',
    next: {
      Assigned: 'Baixe os arquivos de origem, grave sua voz e depois envie sua faixa de voz aqui.',
      InProgress: 'Quando sua faixa de voz estiver pronta, envie abaixo.',
      Submitted: 'Sua dublagem foi enviada para revisão. Você vai receber uma mensagem no Discord quando ela for revisada.',
      ChangesRequested: 'Foram solicitadas alterações. Leia o feedback abaixo e envie uma nova versão.',
      Approved: 'Aprovada. Obrigado!',
    },
    notes: 'Observações',
    sourceFiles: 'Arquivos de origem',
    noFiles: 'Nenhum arquivo foi enviado ainda.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'Um único .mp4 com o vídeo e duas faixas de áudio: a faixa 1 são as falas originais e a faixa 2 é o SFX.',
    uploadTitle: 'Envie sua faixa de voz',
    voiceOnlyTitle: 'Apenas a sua voz',
    voiceOnlyBody:
      'Envie apenas a sua voz gravada: sem música, sem efeitos sonoros e sem nada do áudio original. Confira se ela tem a mesma duração do original.',
    voiceOnlyConfirm: 'Este arquivo contém apenas as falas gravadas.',
    dropLabel: 'Envie aqui sua faixa de voz',
    dropHint: 'Apenas WAV ou MP3.',
    noteForReviewer: 'Observação para quem vai revisar (opcional)',
    lengthTitle: 'A duração não confere',
    lengthBody:
      'Seu arquivo tem {{dub}}, mas a faixa de SFX tem {{sfx}}. Se a sua faixa começar em outro ponto ou estiver cortada, ela não vai ficar sincronizada com o vídeo. Enviar mesmo assim?',
    uploadAnyway: 'Enviar mesmo assim',
    chooseAnother: 'Escolher outro arquivo',
    versions: 'Versões enviadas',
    nothingUploaded: 'Nada foi enviado ainda.',
    version: 'Versão {{version}}',
    reviewApproved: 'Aprovada',
    reviewChanges: 'Alterações solicitadas',
    reviewPending: 'Aguardando revisão',
    yourNote: 'Sua observação:',
    feedback: 'Feedback',
    listen: 'Ouvir',
    uploadedOn: '{{date}} · {{size}}',
    length: 'Duração: {{duration}}',
  },
};
